module.exports = __webpack_public_path__ + "img/p6.00919c6b.jpg";